import moment from "moment";

const formatearTextoFechaIncorrecta = (datos) => {

    const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

    var fecha = new Date(datos["fecha_acceso_examen"]);

    var dia = fecha.getDate() + 1;
    // getDate() obtiene el número del día del mes iniciando en 0. Se le suma 1 para coincidir con el día verdadero

    var mes = meses[fecha.getMonth()];
    // getMonth() obtiene el número del mes iniciando en 0 (enero = 0)

    // hora inicial (hi)
    var hi = moment(datos["hora_inicial_acceso"], "hh:mm").format("LT");
    // LT es para el formato de hora local con minutos, LTS para hora, minutos y segundos

    // hora final (hf)
    var hf = moment(datos["hora_final_acceso"], "hh:mm").format("LT");

    const textoFinal = "La fecha para acceder al examen es el " + dia + " de " + mes + " entre " + hi + " y " + hf + ".";

    return textoFinal;

}

export default formatearTextoFechaIncorrecta;